import React from "react";
import css from "./style.scss";
import cn from "classnames";
import { StatTitle, NumberBox } from "./utils";

class TapsSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      taps_forward: 0,
      taps_back: 0,
    };
  }

  loadStats = (props) => {
    let obj = props.stories.reduce(
      (obj, story) => {
        obj.taps_back =
          obj.taps_back +
          (story.insights.taps_back * 100) / story.insights.reach;
        obj.taps_forward =
          obj.taps_forward +
          (story.insights.taps_forward * 100) / story.insights.reach;
        return obj;
      },
      { taps_forward: 0, taps_back: 0 }
    );
    obj.taps_forward = (obj.taps_forward / (props.stories.length || 1)).toFixed(
      2
    );
    obj.taps_back = (obj.taps_back / (props.stories.length || 1)).toFixed(2);
    this.setState(obj);
  };
  componentDidMount() {
    // this.loadStats(this.props)
  }
  componentWillReceiveProps(props) {
    // this.loadStats(props)
  }

  render() {
    return (
      <div className={cn(this.props.className, css.statsBox)}>
        <StatTitle>Interaction</StatTitle>
        <div>
          <p>
            Number of taps on{" "}
            {this.props.adventure ? " this adventure" : " your stories"}
          </p>
          <div className={css.generalContainer}>
            <NumberBox className={css.generalBox} title="Taps Forward">
              {this.state.taps_forward}
              <small>%</small>
            </NumberBox>
            <NumberBox className={css.generalBox} title="Taps Back">
              {this.state.taps_back}
              <small>%</small>
            </NumberBox>
          </div>
        </div>
      </div>
    );
  }
}

export default TapsSection;



// WEBPACK FOOTER //
// ./src/components/account_page/stats/sections/taps.js